module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade modal-receipt-transfer",
    attrs: {
      "id": "modal-receipt-transfer",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "modal-receipt-transfer-label"
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeModal()
      }
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content window-print"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close hidden-print",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title text-center upper",
    attrs: {
      "id": "modal-receipt-transfer-label"
    }
  }, [_vm._v("comprovante de transferência de créditos")])]), _vm._v(" "), (_vm.dataTransfer) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "receipt-header"
  }, [_c('img', {
    attrs: {
      "src": "/static/Logo_Move_Mais_Horizontal+TAG_Pedagio.svg",
      "alt": "Logo Move Mais TAG"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('p', {
    staticClass: "upper"
  }, [_vm._v("n° comprovante")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.dataTransfer.orderId))]), _vm._v(" "), _c('p', {
    staticClass: "upper"
  }, [_vm._v("data da transferência")]), _vm._v(" "), _c('p', {
    attrs: {
      "mask-date-hour": ""
    }
  }, [_vm._v(_vm._s(_vm._f("dateTime")(_vm.dataTransfer.createdDate)))])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "receipt-info"
  }, [_c('div', {}, [_c('p', {
    staticClass: "margin-b30 upper"
  }, [_vm._v("conta creditada")]), _vm._v(" "), _c('p', {
    staticClass: "upper"
  }, [_vm._v(_vm._s(_vm.dataTransfer.userCred))]), _vm._v(" "), _c('p', [_vm._v("CNPJ: "), _c('span', [_vm._v(_vm._s(_vm._f("cpfCnpj")(_vm.orderData.cnpjCred)))])]), _vm._v(" "), _c('p', [_vm._v("N° do CONTRATO: "), _c('span', [_vm._v(_vm._s(_vm.dataTransfer.contractIdCred))])]), _vm._v(" "), _c('p', [_vm._v("PLANO: "), _c('span', [_vm._v(_vm._s(_vm.orderData.planCred))])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('p', {
    staticClass: "margin-b30 upper"
  }, [_vm._v("conta debitada")]), _vm._v(" "), _c('p', {
    staticClass: "upper"
  }, [_vm._v(_vm._s(_vm.dataTransfer.userDeb))]), _vm._v(" "), _c('p', [_vm._v("CNPJ: "), _c('span', [_vm._v(_vm._s(_vm._f("cpfCnpj")(_vm.orderData.cnpjDeb)))])]), _vm._v(" "), _c('p', [_vm._v("N° do CONTRATO: "), _c('span', [_vm._v(_vm._s(_vm.dataTransfer.contractIddeb))])]), _vm._v(" "), _c('p', [_vm._v("PLANO: "), _c('span', [_vm._v(_vm._s(_vm.orderData.planDeb))])])])]), _vm._v(" "), _c('h1', [_vm._v("\n          Valor da transferência\n          "), _c('strong', [_vm._v(_vm._s(_vm._f("cents")(_vm.dataTransfer.transferValue)))])]), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer hidden-print"
  }, [_c('button', {
    staticClass: "btn btn-outline",
    attrs: {
      "type": "button",
      "name": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v("Fechar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-full",
    on: {
      "click": function($event) {
        return _vm.window.print()
      }
    }
  }, [_vm._v("\n          Imprimir comprovante\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-11754b0e!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/shipper/modal-receipt-transfer.vue
// module id = 2048
// module chunks = 1